export default function (context) {
  if (!Object.values(context.$auth.user.roles).includes('ROLE_ADMIN')) {
    return context.redirect('/white-dog/dashboard')
  }
}
